module.exports = __webpack_public_path__ + "img/bg-right.9e7e41c2.png";